<template>
	<div>
		<div class="input-info basic-info-detail" :class="{'item-error': isError}" @touchend="tipClick">
			<a class="placeholder" :class="{'input-tip': showTip, 'error': isError}">{{tipText}}</a>
			<input
				:id="inputId"
				:type="inputType"
				class="my-input"
				:class="{'input-show': showTip}"
				v-model="content"
				:maxlength="maxLength"
				@blur="blurEvent"
				@focus="focusEvent"
				ref="myinput"
				v-focus="focusing"/>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		isError: {
			type: Boolean,
			default: false
		},
		text: {
			type: String,
			default: ''
		},
		tipText: {
			type: String,
			default: ''
		},
		maxLength: {
			type: Number,
			default: 30
		},
		isFocusing: {
			type: Boolean,
			default: false
		},
		inputType: {
			type: String,
			default: 'text'
		},
		inputID: {
			type: String,
			default: ''
		}
	},
	created() {
		this.content = this.text;
		if (this.text) {
			this.showTip = true;
		}
	},
	watch: {
		text(val) {
			this.content = val;
			if (val) {
				this.showTip = true;
			}
		},
		content(val) {
			if (val || this.focusing) {
				this.showTip = true;
			} else {
				this.showTip = false;
			}
			// 输入内容达到上限时(并且是输入过程中)进行校验
			if (val.length === this.maxLength && this.focusing) {
				this.$emit('blurEvent', val);
			} else {
				// 将改变后的值反给父级
				this.$emit('on-change', val);
			}
		},
		isFocusing(val) {
			if (val) {
				this.tipClick();
			}
		}
	},
	data() {
		return {
			inputId:
				this.inputID === ''
					? Math.random()
						.toString(36)
						.substring(3, 10)
					: this.inputID,
			focusing: this.isFocusing,
			showTip: false,
			content: this.text
		};
	},
	methods: {
		tipClick() {
			if (this.focusing === false) {
				this.showTip = true;

				// 焦点延时时间等于动效时间
				// setTimeout(() => {
					this.focusing = true;
					// ios10以上通过自定义指令focus没生效，所以通过手动focus
					document.getElementById(this.inputId).focus();
				// }, 100);

				this.$emit('tipClick', this.content);
			}
		},
		focusEvent() {
			this.focusing = true;
		},
		blurEvent() {
			// 当字数达到上限时会自动校验，防止多次校验
			if (this.content.length < this.maxLength) {
				this.focusing = false;
				if (this.content === '') {
					this.showTip = false;
				}
				this.$emit('blurEvent', this.content);
			}
		}
	},
	directives: {
		focus: {
			inserted: function(el, { value }) {
				if (value) {
					el.focus();
				}
			},
			//当绑定元素插入到DOM中
			update: function(el, { value }) {
				if (value) {
					el.focus(); //元素聚焦
				} else {
					el.blur();
				}
			}
		}
	}
};
</script>
<style lang="scss" scoped>
@import '../../assets/style/public.scss';
.input-info {
  height: px2rem(138px);
  line-height: px2rem(138px);
  font-size: px2rem(38px);
  padding: 0;
}
.placeholder {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
}
.input-tip {
  position: relative;
  padding-top: px2rem(24px);
}
.input-show {
  display: block;
}
.my-input {
  margin: 0 auto;
  font-size: px2rem(38px);
  color: #000;
  text-align: center;
  width: px2rem(600px);
  height: px2rem(52px);
  line-height: px2rem(52px);
}
</style>



// WEBPACK FOOTER //
// myInput.vue?00932221